
import {Component, Vue, Watch} from "vue-property-decorator";
import {TamamlanmayanDosyalarRow, TamamlanmayanDosyaTurKod} from "@/plugins/uyap-plugin/uyap/TamamlanmayanDosyalar";
import {DataTableHeader} from "vuetify";
import {Task} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";
import Dates from "@/components/inputs/Dates.vue";

@Component({
  components: {
    Dates
  }
})
export default class MtsTebligatGonderList extends Vue {
  filterStr = '';
  headers: DataTableHeader[] = [
    {text: "Birim Adı", align: "start", sortable: true, value: "birimAdi"},
    {text: "Dosya Esas Numarası", align: "start", sortable: true, value: "dosyaNo", filterable: true},
    {text: "Açılış Tarihi", value: "dosyaAcilisTarihi", sortable: true},
    {text: "Son İşlem Tarihi", value: "sonIslemTarihi"},
    {text: "Taraflar", value: "taraflar", filterable: true},
  ];
  selectedItems = [];
  selectableItems: Array<TamamlanmayanDosyalarRow> = [];
  onFly = false;
  
  baslangicTarihi: string = '';
  bitisTarihi: string = '';
  selectedDateRange: string = 'son1Ay';

  async created() {
    await this.setSon1Ay();
  }

  formatTarih(tarih: string | null): string {
    if (!tarih) return '';
    // YYYY-MM-DD formatından GG.AA.YYYY formatına çevir
    const parts = tarih.split('-');
    if (parts.length === 3) {
      return `${parts[2]}.${parts[1]}.${parts[0]}`;
    }
    return tarih;
  }

  async setBugun() {
    const bugun = new Date();
    this.baslangicTarihi = bugun.toISOString().substr(0, 10);
    this.bitisTarihi = bugun.toISOString().substr(0, 10);
    this.selectedDateRange = 'bugun';
    await this.loadData();
  }

  async setSon1Hafta() {
    const bugun = new Date();
    const son1Hafta = new Date();
    son1Hafta.setDate(bugun.getDate() - 7);
    this.baslangicTarihi = son1Hafta.toISOString().substr(0, 10);
    this.bitisTarihi = bugun.toISOString().substr(0, 10);
    this.selectedDateRange = 'son1Hafta';
    await this.loadData();
  }

  async setSon1Ay() {
    const bugun = new Date();
    const son1Ay = new Date();
    son1Ay.setMonth(bugun.getMonth() - 1);
    this.baslangicTarihi = son1Ay.toISOString().substr(0, 10);
    this.bitisTarihi = bugun.toISOString().substr(0, 10);
    this.selectedDateRange = 'son1Ay';
    await this.loadData();
  }

  async loadData() {
    try {
      if (!this.baslangicTarihi || !this.bitisTarihi) {
        return;
      }

      let tamamlanmayanlar = await this.$uyap.TamamlanmayanDosyalar().run({
        dosyaTurKod: TamamlanmayanDosyaTurKod.MTS,
        baslangicTarihi: this.formatTarih(this.baslangicTarihi),
        bitisTarihi: this.formatTarih(this.bitisTarihi)
      });
      this.selectableItems = tamamlanmayanlar.filter(x => (x.surecNo == 5 && x.tebligatGonderimAktif != 'H'));//Tebligat gonderilebilecek dosyalar
    } catch (e) {
      this.$toast.error(e.message);
    }
  }

  @Watch('baslangicTarihi')
  onBaslangicTarihiDegisti() {
    // Kullanıcı manuel tarih değiştirdiğinde buton seçimini temizle
    if (this.selectedDateRange && ['bugun', 'son1Hafta', 'son1Ay'].includes(this.selectedDateRange)) {
      this.selectedDateRange = '';
    }
  }

  @Watch('bitisTarihi')
  onBitisTarihiDegisti() {
    // Kullanıcı manuel tarih değiştirdiğinde buton seçimini temizle
    if (this.selectedDateRange && ['bugun', 'son1Hafta', 'son1Ay'].includes(this.selectedDateRange)) {
      this.selectedDateRange = '';
    }
  }

  async createTask() {
    this.onFly = true;
    if (this.selectedItems.length > 0) {
      let tasks: Array<Task> = [];
      this.selectedItems.forEach((item: any) => {
        let task: Task = new Task();
        task.dosya_esas_no = item.dosyaNo
        task.birim_adi = item.birimAdi
        task.task_type_id = TaskTuru.mts_tebligat_gonder
        task.data = {
          adresTuru: "ADRTR00008",
          dosya: {
            dosyaNo: item.dosyaNo,
            dosyaId: item.dosyaID,
            taraflar: item.taraflar
          }
        }
        tasks.push(task);
      });
      await this.$store.dispatch('postTasks', tasks);
    }
    this.onFly = false;
  }
}
